import { ApiError, errorMessage, NETWORK_ERROR_MESSAGE } from './client.api-adapter.js';

export class AuthApiAdapter {
  #baseUrl;

  constructor(baseUrl) {
    this.#baseUrl = baseUrl;
  }

  /** @param {{email: string, password: string}} request
   *  @returns {Promise<{token: string, email: string}>} */
  async login(request) {
    let response;
    try {
      response = await fetch(`${this.#baseUrl}/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(request),
        cache: 'no-store',
      });
    } catch {
      throw new ApiError(0, NETWORK_ERROR_MESSAGE);
    }
    if (!response.ok) {
      throw new ApiError(response.status, errorMessage(response.status, await response.text()));
    }
    return response.json();
  }
}
